export default {
    duration: 180,
    correctScore: 10,
};
